import React from 'react';
import { Input } from 'components/form/input';
import { SelectCurrency } from 'components/form/compobox/select-priceand-unit';
import CheckboxCustom from 'components/form/checkboxone';
import { useFormikContext } from 'formik';

// Ant Design Select
import { Select } from 'antd';

export default function PriceSectionHome({ idx }) {
  const { values, setFieldValue } = useFormikContext();

  // Seçenekler dizisi
  const cardTypeOptions = [
    'General Textile',
    'Special measures',
    'Adult apparel',
    'Kids apparel',
    'Object',
    'Stationery',
    'Basket',
    'Food contact',
    'Textile'
  ];

  return (
    <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
      {/* Grid Layout - Full Width */}
      <div className="mb-2 grid grid-cols-1 gap-4 text-sm font-medium text-simsek">
        {/* Card Type */}
        <div className="flex items-center">
          <label style={{minWidth:100}} className="block text-sm font-medium text-simsek mb-1">
            Card Type
          </label>
          <Select
            id={`zaraHomeLabel11[${idx}].cardType`}
            value={values.zaraHomeLabel11[idx].cardType || undefined}
            placeholder="Seçiniz"
            allowClear
            onChange={(val) => setFieldValue(`zaraHomeLabel11[${idx}].cardType`, val)}
            className="w-full h-10"
          >
            {cardTypeOptions.map((type) => (
              <Select.Option key={type} value={type}>
                {type}
              </Select.Option>
            ))}
          </Select>
        </div>

        {/* RFID checkbox */}
        <div className="flex items-center">
          <CheckboxCustom
            label="Siparişte RFID'li etiket var mı?"
            name={`zaraHomeLabel11[${idx}].hasRFID`}
            idx={idx}
          />
        </div>

        {/* Kart Açıklama - Sağ tarafa */}
   
      </div>
      {/* AntD Select ile Card Type */}
      <div className="mb-2 grid grid-cols-1 gap-4 text-sm font-medium text-simsek">

          <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-start",paddingLeft:10,marginTop:-45 }}>
            <label
              style={{
                fontSize: "13px",
                fontWeight: 500,
                marginRight: "8px",
                minWidth:120,
              }}
            >
              KART AÇIKLAMA
            </label>
            <div style={{width:"100%"}}>
            <Input
              name={`zaraHomeLabel11[${idx}].carddesc`}
              autoComplete="off"
                style={{
                  width: "100%",
                cursor: "pointer",
              }}
            />
            </div>
          </div>

        </div>

    </div>
  );
}
